import { render } from "./VerificarCorreo.vue?vue&type=template&id=0f75ecbc&scoped=true"
import script from "./VerificarCorreo.vue?vue&type=script&lang=js"
export * from "./VerificarCorreo.vue?vue&type=script&lang=js"

import "./VerificarCorreo.vue?vue&type=style&index=0&id=0f75ecbc&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\portalalumnos\\portalalumnos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f75ecbc"]])

export default __exports__